/* eslint-disable no-new */
import axios from 'axios';
import Vue from 'vue';
import VueAxios from 'vue-axios';
import TranslatePlugin from '../shared/TranslatePlugin';
import SeedPointScore from './seed-point-score.vue';
import OrderHistory from './order-history.vue';
import CollectSeedpointsForm from './collect-seedpoints-form.vue';
import AwardCheckout from './award-checkout.vue';
import AwardCheckoutCart from './award-checkout-cart.vue';
import AwardDetail from './award-detail.vue';
import AwardList from './award-list.vue';
import ComponentInitializer from '../shared/ComponentInitializer';

Vue.use(VueAxios, axios);
Vue.use(TranslatePlugin);
Vue.config.productionTip = false;

ComponentInitializer.initVueComponents([
  { component: OrderHistory, dataAttribute: 'data-order-history' },
  { component: SeedPointScore, dataAttribute: 'data-seed-point-score' },
  { component: CollectSeedpointsForm, dataAttribute: 'data-collect-seedpoints-form' },
  { component: AwardCheckout, dataAttribute: 'data-award-checkout' },
  { component: AwardDetail, dataAttribute: 'data-award-detail' },
  { component: AwardList, dataAttribute: 'data-award-list' },
  { component: AwardCheckoutCart, dataAttribute: 'data-award-checkout-cart' },
]);
